import React from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../app/hooks';
import { CalendarEvent, Day } from '../helpers/common-types';
import { SvgIcon } from './svg-icon';

export const GridDay = (props: { dayItem: Day, dayIndex: number, withinMonth: boolean, modifiers: string }) => {
    const { dayItem, dayIndex, withinMonth, modifiers } = props;
    const buyTicketCtaDefaultText = useAppSelector(state => state.settings.buyTicketCtaDefaultText);
    const soldOutDefaultText = useAppSelector(state => state.settings.souldOutText);
    const dayItemEventsSortedByTime = dayItem.events.length > 1 ? [...dayItem.events].sort((a, b) => dayjs(a.eventDate) - dayjs(b.eventDate)) : dayItem.events;
    const getTitle = (name: string | undefined) => (<h3 className="h4-style ace-cal-grid-event-name" dangerouslySetInnerHTML={{ __html: name || "" }}></h3>);
    const getCta = (buyTicketText: string | undefined) => buyTicketText ? buyTicketText : buyTicketCtaDefaultText;
    const getSoldOutText = (soldOutText: string | undefined) => soldOutText || soldOutDefaultText;

    return (
        <li className={`ace-cal-grid-day ${modifiers}`} key={dayIndex} aria-hidden={!withinMonth}>
            <span className="ace-cal-grid-day-date" tabIndex={-1}>{dayjs(dayItem.date).format("D")}</span>
            {
                dayItemEventsSortedByTime.length > 0 &&
                <ul className="ace-cal-grid-day-content">
                    {
                            dayItemEventsSortedByTime.map(event => (
                            <li className="ace-cal-grid-event">
                                <div className="ace-cal-grid-event-content">
                                    {
                                        event.viewDetailCtaUrl ?
                                            <a href={event.viewDetailCtaUrl}>{getTitle(event.name)}</a>
                                            : getTitle(event.name)
                                    }
                                    <p className="ace-cal-grid-event-time">{event.eventTimeString}</p>
                                    <p className="ace-cal-grid-event-venue">
                                        <span>{event.location}</span>
                                    </p>
                                    {
                                        event.availabilityIndicatorText &&
                                            <p className={`availability-${event.availabilityClass}`}>
                                            <span>{event.availabilityIndicatorText}</span>
                                        </p>
                                    }
                                    <p className="ace-cal-grid-event-cta">
                                        {
                                            event.isSoldOut ?
                                                <>
                                                    {getSoldOutText(event.soldOutText) && <span className="btn-secondary" data-disabled>{getSoldOutText(event.soldOutText)}</span>}
                                                </>
                                                : <>
                                                    {
                                                        event.buyTicketCtaUrl ?
                                                                <a href={event.buyTicketCtaUrl} onClick={(e) => {
                                                                    (e.target as HTMLElement).classList.add('btn-loading');
                                                                    (e.target as HTMLLinkElement).setAttribute('disabled', 'true');
                                                                }} className="btn">{getCta(event.buyTicketCtaText)}</a>
                                                            : getCta(event.buyTicketCtaText)
                                                    }
                                                </>
                                        }
                                    </p>
                                </div>
                            </li>
                        ))
                    }
                </ul>
            }
        </li>
    )
}